/**
 * StructuredData is now rendered statically in index.html <head>
 * and updated at build time by the trustpilot-prerender Vite plugin.
 * This component is kept as a no-op to avoid breaking imports.
 */
const StructuredData = () => null;

export default StructuredData;
